import toast from "react-hot-toast";
import * as api from "../Api";
import { approvedInvestments } from "./approvedInvestment";
import { getAllInvestment } from "./investment";
import { getInstitutionStats } from "./institutionStats";
import { monthStats } from "./monthStats";

export const RedeemedInvestment = (id, postData) => async (dispatch) => {
  const rediscountingId = toast.loading("Rediscounting investment...");
  try {
    const { data } = await api.updateInvestment(id, postData);
    dispatch({ type: "REDEEM_INVESTMENT", payload: data });
    // The maturity date moved, so the dashboard and reports need it too
    dispatch(approvedInvestments());
    dispatch(getAllInvestment());
    dispatch(monthStats());
    dispatch(getInstitutionStats());
    toast.remove(rediscountingId);
    toast.success("Investment rediscounted");
    return data;
  } catch (error) {
    toast.remove(rediscountingId);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong",
    );
    throw error;
  }
};

export const getRedeemedInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.getRedeemedInvestments();
    dispatch({ type: "ALL_REDEEMED_INVESTMENT", payload: data });
  } catch (error) {}
};
